import React from 'react';

import ExpansionPanel, {ExpansionPanelDetails, ExpansionPanelSummary,} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import Typography from 'material-ui/Typography';

import Button from 'material-ui/Button';

import Input, {InputAdornment, InputLabel} from 'material-ui/Input';
import TextField from 'material-ui/TextField';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';
import Select from 'material-ui/Select';
import Radio, {RadioGroup} from 'material-ui/Radio';
import {FormControlLabel} from 'material-ui/Form';

import { DatePicker } from 'material-ui-pickers';

import Grid from 'material-ui/Grid';

import {FilterList, ArrowDownward, ArrowUpward} from 'material-ui-icons';

import tsl from './../../../tsl';

import axios from 'axios';
import moment from 'moment-timezone';

export default class Filter extends React.Component {
	
	state = {
		statuses: [],
		types: [],
		locations: [],
		aircrafts: [],
		filters: {
			flight_type: [],
			status: [],
			location: [],
			aircraft: [],
			date: null,
			date_to: null,
			orderBy: '',
			booking_id: '',
			order: 'desc'	// desc / asc
		},
		filter_displayed: false,
	}

	componentWillReceiveProps = (newProps) => {
		this.setState({ filters: newProps.filter });
	}

	componentDidMount() {
		axios.get('/api/flight/types')
			.then((res) => { 
				this.setState({ types: res.data })
			})

		axios.get('/api/flight/statuses')
			.then((res) => {
				let state = this.state;
				state.statuses = res.data;	// set loaded statuses
				
				// predefine filter of statuses
				state.filters.status = res.data 	
					.filter(status => (status.name != 'CANCELED'))	// filter to all statuses except name=CANCELED
					.map(status => status.id);	// convert array of object to array of it's IDs

				this.setState(state);
				this.propagateChanges(state.filters);
			})

		axios.get('/api/operator/flight/locations')
			.then((res) => { 
				this.setState({ locations: res.data.data })
			})

		axios.get('/api/operator/aircrafts')
			.then((res) => { 
				this.setState({ aircrafts: res.data.data })
			})
	}

	propagateChanges = (filter) => {
		this.props.onChange(filter);
		//console.log('filter state',this.state.filters);
	}

	filterChange = (name) => (e) => {
		//console.log(name, e.target.value);
		let filters = this.state.filters;
		filters[name] = e.target.value;
		this.setState({ filters: filters });
		this.propagateChanges(filters);
	};

	delayedPropagation = (timeout = 1250) => {
		if (this.propagationTimout) {
			clearTimeout(this.propagationTimout);
		}

		this.propagationTimout = setTimeout(() => {
			this.propagateChanges(this.state.filters);
		}, timeout)
	};

	handleInputChange = (name) => (e) => {
		var target = e.target;

		this.setState(state => ({
			filters: {
				...state.filters,
				[name]: target.value
			}
		}), this.delayedPropagation)
	};

	handleDateChange = (name) => (value) => {
		let filters = this.state.filters;
		filters[name] = value ? value.format('YYYY-MM-DD') : null;
		this.setState({ filters: filters });
		this.propagateChanges(filters);
	}

	orderChange = (e) => {
		let filters = this.state.filters;
		filters.order = e.target.value;
		this.setState({ filters: filters });
		this.propagateChanges(filters);
	}

	/*
	orderBy = (column) => () => {
		this.setState({ 
			orderBy: column,
			// change order if the filter is already at this column
			orderDesc: (this.state.orderBy == column) ? !this.state.orderDesc : this.state.orderDesc
		});
	}*/

	filterCollapse = () => {
		this.setState({
			filter_displayed: !this.state.filter_displayed
		});
	}

	render() {
		return (
			<ExpansionPanel expanded={this.state.filter_displayed} onChange={this.filterCollapse}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                	<FilterList />
                    <Typography>{tsl('flights.filter.header')}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>

	            	<Grid container spacing={8}>
	            		{/* 
	            		<Grid item sm={3} xs={12}>
		                    <Button onClick={this.orderBy('time')}>
								{tsl('flights.filter.time_sort_btn')}
								{this.state.orderBy == 'time'? (this.state.orderDesc ? <ArrowDownward /> : <ArrowUpward />) : ''}
		                    </Button>
		                </Grid>
		            	*/}

		                <Grid item sm={4} md={3} md={3} xs={12}>
		                    <FormControl fullWidth >
		                      <InputLabel htmlFor="status">{tsl('flights.filter.by_status')}</InputLabel>
		                      <Select
		                        name="status"
		                        multiple
		                        value={this.state.filters.status || []}
		                        onChange={this.filterChange('status')}
		                      >
		                        {this.state.statuses.map((status) => {
		                            return (<MenuItem key={status.id} value={status.id}>{status.title}</MenuItem>);
		                        })}
		                      </Select>
		                    </FormControl>
		                </Grid>

		                <Grid item sm={4} md={3} md={3} xs={12}>
		                    <FormControl fullWidth >
		                      <InputLabel htmlFor="location">{tsl('flights.filter.by_location')}</InputLabel>
		                      <Select
		                        name="location"
		                        multiple
		                        value={this.state.filters.location || []}
		                        onChange={this.filterChange('location')}
		                      >
		                        {this.state.locations.map((loc) => {
		                            return (<MenuItem key={loc.id} value={loc.id}>{loc.name}</MenuItem>);
		                        })}
		                      </Select>
		                    </FormControl>
	                    </Grid>

	                    <Grid item sm={4} md={3} xs={12}>
		                    <FormControl fullWidth >
		                      <InputLabel htmlFor="flight_type">{tsl('flights.filter.by_type')}</InputLabel>
		                      <Select
		                        name="flight_type"
		                        multiple
		                        value={this.state.filters.flight_type || []}
		                        onChange={this.filterChange('flight_type')}
		                      >
		                        {this.state.types.map((type) => {
		                            return (<MenuItem key={type.id} value={type.id}>{type.title}</MenuItem>);
		                        })}
		                      </Select>
		                    </FormControl>
		                </Grid>

		                <Grid item sm={4} md={3} xs={12}>
		                    <FormControl fullWidth >
		                      <InputLabel htmlFor="flight_type">{tsl('flights.filter.by_aircraft')}</InputLabel>
		                      <Select
		                        name="aircraft"
		                        multiple
		                        value={this.state.filters.aircraft || []}
		                        onChange={this.filterChange('aircraft')}
		                      >
		                        {this.state.aircrafts.map((aircraft) => {
		                            return (<MenuItem key={aircraft.id} value={aircraft.id}>{aircraft.reg_no + ' ('+aircraft.model.name+')'}</MenuItem>);
		                        })}
		                      </Select>
		                    </FormControl>
		                </Grid>

		                <Grid item sm={4} md={3} xs={12}>
	                		<DatePicker
	                			fullWidth
	                			label={tsl('flights.filter.date')}
	                			format="LL"
				                value={this.state.filters.date || null}
				                onChange={this.handleDateChange('date')}
				                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
				                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
				                invalidLabel=""
	                		 />
	                		 {this.state.filters.date
	                		 	? <Button 
		                		 		className="w-100"
		                		 		onClick={() => {this.handleDateChange('date').call()}}
	                		 		>
	                		 			{tsl('flights.filter.date_clear')}
	                		 		</Button>
	                		 	: ''
	                		 }
		                </Grid>

						<Grid item sm={4} md={3} xs={12}>
							<DatePicker
								fullWidth
								label={tsl('flights.filter.date_to')}
								format="LL"
								value={this.state.filters.date_to || null}
								onChange={this.handleDateChange('date_to')}
								leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
								rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
								invalidLabel=""
								placeholder={this.state.filters.date ? moment(this.state.filters.date).format("LL") : null}
							/>
							{this.state.filters.date_to
								? <Button
									className="w-100"
									onClick={() => {this.handleDateChange('date_to').call()}}
								>
									{tsl('flights.filter.date_clear')}
								</Button>
								: ''
							}
						</Grid>

										<Grid item sm={4} md={3} xs={12}>
	                		<TextField
												name="booking_id"
												onChange={this.handleInputChange('booking_id')}
												value={this.state.filters.booking_id}
												label={tsl('flights.filter.booking_id')}
												fullWidth
												type="number"
												inputProps={{
													step: 1
                        }}
											/>
		                </Grid>

		                <Grid item sm={4} md={3} xs={12}>
		                	<RadioGroup
					            aria-label="order"
					            name="order"
					            value={this.state.filters.order}
					            onChange={this.orderChange}
					            className="d-flex flex-row"
					         >
					            <FormControlLabel 
					            	value="desc" 
					            	control={<Radio />} 
					            	label={<i className="zmdi zmdi-sort-amount-desc zmdi-hc-2x"></i>}
					            />
					            <FormControlLabel
					            	value="asc"
					            	control={<Radio />}
					            	label={<i className="zmdi zmdi-sort-amount-asc zmdi-hc-2x"></i>}
					            />
					        </RadioGroup>

		                </Grid>

	            	</Grid>

	            </ExpansionPanelDetails>

            </ExpansionPanel>
		);
	}
}


// WEBPACK FOOTER //
// ./app/used/flights/routes/Filter.js